module.exports = __webpack_public_path__ + "static/img/QR_wechat_official.e0cb01bd.png";